import React from 'react';
import { Button } from "../../../ui";

export interface NavigationButtonProps {
    onClickAction: () => void
}

export const BackNavButton = (props: NavigationButtonProps) => (
    <div className='navigation-button' data-testid="back-button">
        <Button icon='semantic-back' name='semantic-back' ariaLabel='Back' secondary
            title='Back'
            onClick={props.onClickAction} />
    </div>
)

export const RefreshNavButton = (props: NavigationButtonProps) => (
    <div className='navigation-button' data-testid="reload-button">
        <Button icon='semantic-reload' ariaLabel='Reload' name='semantic-reload' secondary
            title='Refresh'
            onClick={props.onClickAction} />
    </div>
)
export const LogoutNavButton = (props: NavigationButtonProps) => (
    <div className='navigation-button' data-testid="logout-button">
        <Button icon='logout' ariaLabel='Logout' name='logout' secondary
            title='Logout'
            onClick={props.onClickAction} />
    </div>
)